module.exports = __webpack_public_path__ + "img/logo.a265e02b.png";